module.exports = __webpack_public_path__ + "img/yesmovies-alternatives.70dfa22b.png";